export default "__VITE_ASSET__UPPy55w5__"